export default __webpack_public_path__ + "static/media/HistoricDescription.efd55d08.svg";